export function getDirection() {
  if (typeof document === 'undefined') {
    return 'ltr'
  }

  const htmlDir = document.documentElement.dir.toLowerCase()
  return htmlDir === 'rtl' ? 'rtl' : 'ltr'
}

export const isRTL = () => getDirection() === 'rtl'

export function rtlLeftNormalizer(left: number) {
  if (isRTL()) {
    return left * -1
  }
  return left
}
